// create a GuxTag with a label Preview
import { GuxTag, GuxTooltip } from "genesys-spark-components-react";
import strings from "./PreviewTag.strings";
import { useStrings } from "features/i18n/useStrings";
import { FeatureGate } from "features/featureToggles/FeatureGate";
import FeatureToggle from "enums/FeatureToggle";
import { useAppSelector } from "app/hooks";
import { selectFeatureToggle } from "features/featureToggles/featureToggleSlice";
import TagAccent from "enums/TagAccent";

function PreviewTag({
    disabled = false,
    showTooltip,
}: {
    disabled: boolean;
    showTooltip: boolean;
}) {
    const t = useStrings(strings);
    const isFlareThemeEnabled = useAppSelector((state) =>
        selectFeatureToggle(state, FeatureToggle.SPARK_FLARE)
    );
    const tagAccent = isFlareThemeEnabled ? TagAccent.FLARE : TagAccent.LEGACY;

    return (
        <FeatureGate
            flag={FeatureToggle.USE_OUTER_LIMITS}
            showWhenEnabled={false}
        >
            <div>
                <GuxTag
                    accent={tagAccent}
                    emphasis="subtle"
                    data-testid="ai-scoring-preview"
                    disabled={disabled}
                    aria-disabled={disabled}
                >
                    <span>{t.label}</span>
                </GuxTag>
                {showTooltip && <GuxTooltip>{t.tooltip}</GuxTooltip>}
            </div>
        </FeatureGate>
    );
}

export default PreviewTag;
